(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("map-opacity", [], factory);
	else if(typeof exports === 'object')
		exports["map-opacity"] = factory();
	else
		root["map-opacity"] = factory();
})(self, function() {
return 